@if (initialized()) {
  <div class="page">
    <div class="container py-4 py-lg-5">
      <!-- Hero -->
      <div class="row py-3 g-3 hero-row">
        <!-- medias -->
        @for (article of data().medias; track article.id) {
          @if ($index < 2) {
            <div
              [ngClass]="{ 'col-md-8': $index == 0, 'col-md-4': $index == 1 }"
            >
              <div
                class="hero-card d-flex"
                [style.background-image]="
                  'url(' + (article.image | assetFormatter) + ')'
                "
              >
                <div class="align-self-end hero-card-content p-3">
                  <span class="category-badge">
                    {{ article.subject?.name }}
                  </span>

                  <h2>
                    <a
                      [routerLink]="['/articulo', article.slug]"
                      class="text-white link-olive"
                    >
                      {{ article.title }}
                    </a>
                  </h2>

                  <a
                    class="h5 author-label font-monospace text-white"
                    [routerLink]="['/buscar']"
                    [queryParams]="{ a: article.author?.id }"
                  >
                    Por
                    {{ article.author?.name + " " + article.author?.surname }}
                  </a>
                </div>
              </div>
            </div>
          } @else {
            <div class="col-6 col-md-3">
              <a [routerLink]="['/articulo', article.slug]" class="img-article">
                <img
                  class="img-zoomable"
                  [src]="article.image | assetFormatter"
                  [alt]="article.title"
                />
              </a>

              <hr class="separator my-2" />

              <h4 class="h5">
                <a
                  [routerLink]="['/articulo', article.slug]"
                  class="text-decoration-none"
                >
                  {{ article.title }}
                </a>
              </h4>

              <a
                class="author-label"
                [routerLink]="['/buscar']"
                [queryParams]="{ a: article.author?.id }"
              >
                {{ article.author?.name + " " + article.author?.surname }}
              </a>
            </div>
          }

          @if ($index == 1) {
            <div class="w-100 my-4"></div>
          }
        }
      </div>

      <!-- Current issue -->
      @if (data().magazine) {
        <div class="w-100 issue-promo py-4 mt-5">
          <div class="container px-md-3">
            <div class="row py-3 align-items-center px-3">
              <div class="col-md-auto">
                <div class="issue-promo-image w-100">
                  <img
                    [src]="data().magazine!.cover | assetFormatter"
                    class="img-fluid"
                    alt="Portada Liber"
                  />
                </div>
              </div>

              @if (data().magazine) {
                <div class="col-md">
                  <div
                    class="issue-promo-content w-100 px-md-4 d-flex align-items-center pt-3"
                  >
                    <div>
                      <div class="liber-number h2">
                        <div>
                          <p class="h1 display-5 font-monospace mb-0">Liber</p>
                        </div>

                        <div class="liber-number-circle">
                          {{ data().magazine!.number }}
                        </div>

                        <div>
                          <img
                            src="/img/logo-ac-sm.webp"
                            height="35"
                            alt="Arte y Cultura"
                          />
                        </div>
                      </div>

                      <p class="h4 mt-3 mb-4">
                        <a
                          [routerLink]="['/liber', data().magazine!.slug]"
                          class="text-decoration-none text-olive"
                        >
                          {{ data().magazine!.topic }}
                        </a>
                      </p>

                      <p class="h6 issue-promo-season text-uppercase">
                        {{ data().magazine!.season }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-auto text-end">
                  <div class="d-flex flex-column">
                    <a
                      [routerLink]="['/liber', data().magazine!.slug]"
                      class="btn btn-outline-dark btn-md mb-3"
                    >
                      Ver contenido
                    </a>

                    @if (data().magazine!.pdf[0]) {
                      <a
                        [href]="
                          data().magazine!.pdf[0]?.download_link
                            | assetFormatter
                        "
                        target="_blank"
                        rel="noopener"
                        class="btn btn-primary btn-md"
                      >
                        Ver Liber en PDF
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <!-- presents -->
      <div class="row pt-3 mt-5">
        <div class="col">
          <h4 class="mb-0">Actualidad</h4>
          <hr class="separator mt-2 mb-3" />
        </div>
      </div>

      <div class="row pt-1 pb-3 g-4 mb-4">
        @for (article of data().presents; track article.slug) {
          <div class="col-6 col-md-3">
            <a
              class="img-article-ratio"
              [routerLink]="['/articulo', article.slug]"
            >
              <img
                [src]="article.image | assetFormatter"
                class="img-zoomable"
                [alt]="article.title"
              />
            </a>
            <hr class="separator my-2" />
            <h4 class="h4 mb-0">
              <a [routerLink]="['/articulo', article.slug]">
                {{ article.title }}
              </a>
            </h4>
          </div>
        }
      </div>

      <!-- Authors + most read -->
      <div class="row pt-1 pb-3 g-4 mt-4">
        <div class="col-md-7">
          <h4 class="mb-0">Autores Liber</h4>

          <hr class="separator my-2" />

          <div class="w-100 px-2">
            <app-carousel
              [items]="data().authors"
              [duplicate]="false"
            ></app-carousel>
          </div>
        </div>

        <div class="col-md-5">
          <h4 class="mb-0">Artículos más leídos</h4>

          <hr class="separator mt-2 mb-3" />

          <div class="mt-3">
            @for (
              article of data().moreread;
              track article.slug;
              let last = $last
            ) {
              <div class="d-flex align-items-center">
                <div>
                  <div class="img-avatar-ratio">
                    <img
                      [src]="article.image | assetFormatter"
                      [alt]="article.title"
                    />
                  </div>
                </div>

                <div class="ps-2">
                  <h4 class="h5">
                    <a [routerLink]="['/articulo', article.slug]">
                      {{ article.title }}
                    </a>
                  </h4>

                  <a
                    class="author-label"
                    [routerLink]="['/buscar']"
                    [queryParams]="{ a: article.author?.id }"
                  >
                    {{ article.author?.name + " " + article.author?.surname }}
                  </a>
                </div>
              </div>

              <div class="my-4">
                <hr />
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Para saber más -->
      <div class="row pt-3 mt-3">
        <div class="col">
          <h4 class="mb-0">Para saber más</h4>
          <hr class="separator mt-2 mb-3" />
        </div>
      </div>
      <div class="row pt-1 pb-3 g-4">
        @for (article of data().knowmore; track article.slug) {
          <div class="col-6 col-md-3">
            <div>
              <a
                [routerLink]="['/articulo', article.slug]"
                class="img-article-ratio"
              >
                <img
                  class="img-zoomable"
                  [src]="article.image | assetFormatter"
                  [alt]="article.title"
                />
              </a>
            </div>

            <hr class="separator my-2" />
            <h4 class="h4 mb-0">
              <a [routerLink]="['/articulo', article.slug]">
                {{ article.title }}
              </a>
            </h4>
          </div>
        }
      </div>

      <!-- Key tags + latest -->
      <div class="row pt-1 pb-3 g-4 mt-3">
        <div class="col-md-7">
          <h4 class="mb-0">Claves</h4>

          <hr class="separator my-2" />

          <app-carousel
            [items]="data().tags"
            carouselType="tags"
          ></app-carousel>
        </div>

        <div class="col-md-5">
          <div class="card bg-light-olive py-2">
            <div class="card-body">
              <div class="row gy-3 w-100 py-2">
                <div class="col-12">
                  <h4 class="mb-0">Lo último en Liber</h4>

                  <hr class="separator mt-2 mb-3" />
                </div>

                @for (item of data().latest; track $index) {
                  <div class="col-12">
                    <div class="d-flex">
                      <div>
                        <div class="img-avatar-ratio">
                          <img
                            [src]="item.image | assetFormatter"
                            [alt]="item.title"
                          />
                        </div>
                      </div>

                      <div class="ps-2">
                        <h4 class="h5">
                          <a [routerLink]="['/articulo', item.slug]">
                            {{ item.title }}
                          </a>
                        </h4>

                        <a
                          class="author-label"
                          [routerLink]="['/buscar']"
                          [queryParams]="{ a: item.author?.id }"
                        >
                          {{ item.author?.name + " " + item.author?.surname }}
                        </a>
                      </div>
                    </div>

                    <hr />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Instantes -->
      <div class="row pt-3 mt-3">
        <div class="col">
          <h4 class="mb-0">Instantes</h4>

          <hr class="separator mt-2 mb-3" />
        </div>
      </div>

      <div class="row pt-1 pb-3 g-4">
        @for (short of data().shorts; track short.id) {
          <div class="col-6 col-md-3">
            <div class="short-container">
              <iframe
                [src]="short.url | safeEmbedPipe"
                [title]="short.name"
                frameborder="0"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                "
                allowfullscreen
              ></iframe>
            </div>

            <p class="h5 mt-2 text-secondary">
              {{ short.name }}
            </p>
          </div>
        }
      </div>

      <!-- ! ARTICLES -->
      <div class="row pt-3 gy-3">
        <!-- Current issue spotlight -->
        @if (data().articles[0]) {
          @if (data().articles[0].magazine) {
            <div class="col-12 mb-4">
              <h5 class="mb-0 heading-separator">
                <span> {{ data().articles[0].magazine?.title }} </span>
              </h5>
            </div>
          }

          <div class="co-12 d-block">
            <div class="row gy-3 gy-md-0 spotlight-panel mb-4">
              <div class="col-md-6 px-0 spotlight-image">
                <a [routerLink]="['/articulo', data().articles[0].slug]">
                  <img
                    class="img-fluid"
                    [src]="data().articles[0].image | assetFormatter"
                    [alt]="data().articles[0].title"
                    width="100%"
                  />
                </a>
              </div>
              <div class="col-md-6 align-self-end d-flex px-4 pt-4">
                <div class="align-self-end py-4">
                  @if (data().articles[0].subject) {
                    <span class="category-badge text-white mb-3">
                      {{ data().articles[0].subject?.name }}
                    </span>
                  }

                  <h3>
                    <a
                      [routerLink]="['/articulo', data().articles[0].slug]"
                      class="text-white"
                    >
                      {{ data().articles[0].title }}
                    </a>
                  </h3>

                  @if (data().articles[0].meta_description) {
                    <div
                      class="text-white"
                      [innerHTML]="data().articles[0].meta_description"
                    ></div>

                    <hr class="separator mt-1 mb-3 border-white opacity-50" />
                  }

                  @if (data().articles[0].author) {
                    <a
                      class="author-label text-white"
                      [routerLink]="['/buscar']"
                      [queryParams]="{ a: data().articles[0].author?.id }"
                    >
                      Por
                      {{
                        data().articles[0].author!.name +
                          " " +
                          data().articles[0].author!.surname
                      }}
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (data().articles[1]) {
          <div class="col-md-4">
            <div class="d-flex flex-column">
              <div class="mb-2">
                <a
                  class="secondary-article-img"
                  [routerLink]="['/articulo', data().articles[1]!.slug]"
                >
                  <img
                    [src]="data().articles[1]!.cover | assetFormatter"
                    [alt]="data().articles[1]!.title"
                  />
                </a>
              </div>

              <div class="my-2">
                <span class="category-badge">
                  {{ data().articles[1]!.subject?.name }}
                </span>
              </div>

              <h4 class="mb4">
                <a [routerLink]="['/articulo', data().articles[1]!.slug]">
                  {{ data().articles[1]!.title }}
                </a>
              </h4>

              <div
                class="mb-1"
                [innerHTML]="data().articles[1]!.meta_description"
              ></div>

              <a
                class="author-label"
                [routerLink]="['/buscar']"
                [queryParams]="{ a: data().articles[1]!.author?.id }"
                >Por
                {{
                  data().articles[1]!.author?.name +
                    " " +
                    data().articles[1]!.author?.surname
                }}
              </a>
            </div>
          </div>
        }

        <div class="col-md-8">
          <div class="ps-md-4 pt-4 pt-md-0">
            @for (article of data().articles; track article.slug) {
              @if ($index > 1) {
                <div class="row pb-3">
                  <div class="col-md-4">
                    <a
                      class="img-zoomable-container"
                      [routerLink]="['/articulo', article.slug]"
                    >
                      <img
                        [src]="article.image | assetFormatter"
                        class="img-fluid w-100 img-zoomable"
                        [alt]="article.title"
                      />
                    </a>
                  </div>
                  <div class="col">
                    <hr class="separator mt-4 mt-md-0 mb-2 mb-md-0 pb-2" />
                    @if (article.subject) {
                      <span class="category-badge">
                        {{ article.subject?.name }}
                      </span>
                    }

                    <h4 class="mb-0 h6">
                      <a [routerLink]="['/articulo', article.slug]">
                        {{ article.title }}
                      </a>
                    </h4>

                    <a
                      class="author-label"
                      [routerLink]="['/buscar']"
                      [queryParams]="{ a: article.author?.id }"
                    >
                      Por
                      {{ article.author?.name + " " + article.author?.surname }}
                    </a>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>

      <!-- ! ARTICLES -->

      <!-- Table of contents -->

      <div class="row pt-5">
        <div class="col">
          <h4>Contenido</h4>
        </div>
      </div>

      <app-content [items]="data().marticles"></app-content>

      <!-- Retrospective -->
      <div class="retrospective-section px-4">
        <div class="row pt-5 mt-5 px-3 px-lg-4">
          <div class="col">
            <h4 class="px-3">Liber en retrospectiva</h4>
            <p class="px-3">
              Una selección exclusiva del editor con lo mejor de nuestro archivo
            </p>
          </div>

          <div class="col-12">
            <app-carousel
              [items]="data().hindsight"
              carouselType="hindsight"
            ></app-carousel>
          </div>
        </div>
      </div>

      <!-- Video -->
      <div class="row pt-5">
        <div class="col">
          <h4>Video</h4>
        </div>

        <div class="col-12">
          <app-carousel
            [items]="data().videos"
            carouselType="videos"
          ></app-carousel>
        </div>
      </div>
    </div>
  </div>
}
